// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    /* Store Custom Code - Start */
    color: "#09f",
    style: "solid",
    width: "2px",
    /* Store Custom Code - End */
};

export default focus;
